'use strict';

(function () {
  'use strict';

  angular.module('vnext').controller('StyleguideCtrl', StyleguideCtrl);

  StyleguideCtrl.$inject = ['$log'];

  /* @ngInject */
  function StyleguideCtrl($log) {
    var vm = this;
    vm.title = 'StyleguideCtrl';

    activate();

    ////////////////

    function activate() {
      $log.debug('Styleguide control activate');
    }
  }
})();